import React, {Component} from 'react'
import {Scene, Entity} from 'aframe-react'

import ActionButton from "./ActionButton"
import AspectImage from "./AspectImage"
import TextPlane from "./TextPlane"

import ItemActions from "./ItemActions"

import FadeAnimation from "./FadeAnimation"

import frameBox from "../components-aframe/frameBox"
import frameDepth from "../components-aframe/frameDepth"
import frameButton from "../components-aframe/frameButton"
import fixed from "../components-aframe/fixed"

/**
 * 
 * React Component for tendering Images/Text in space
 * 
 */
class IdeaBox extends Component {

    constructor(props) {
        super(props)

        this.const = {
            size: 0.6,
        }

        this.state = {
            hover: false,

            scale: {x: this.const.size, y: this.const.size, z: 1},

            src: (this.props.item.img) ? this.props.item.img.src : "",

            moving: false,
            direction: 1,
        }

        this.w = 3;
        this.h = 3;

        // this.hideable;
    }

    /**
     * Loads high resolution version of images
     */
    componentDidMount() {

        if (this.props.item.img) {

            fetch("https://protected-reef-44017.herokuapp.com/?url="+this.props.item.img.srcHigh)
            .then( res => {
                if (res.status === 200) {
                    res.text()
                    .then( res => {
                        this.setState({
                            src: res
                        })
                    })
                }
            })
            
        }
    }

    /**
     *  Updated state for hovering
     */
    itemHover() {
        this.setState({
            hover: true,
        });
    }

    /**
     * Update state for unhovering
     */
    itemUnhover() {
        this.setState({
            hover: false,
        });
    }

    /**
     * Fire  delete event
     */
    delClick() {
        this.props.actions.rmvItem(this.props.dKey)
    }

    /**
     * 
     * Saves current rotation to redux state 
     * 
     * @param {vec3} rot - rotation vector
     */
    saveRotation(rot) {
        this.props.actions.saveDrag(this.props.dKey, rot)
    }

    /**
     * 
     * Sets Width and Height of the image
     * 
     * @param {Number} w 
     * @param {Number} h 
     */
    getSize(w, h) {
        this.w = w
        this.h = h
    }


    /**
     * Renders image with aspect ratio
     */
    renderImage () {

        return (
            <AspectImage
                image={{
                    ...this.props.item.img,
                    src: this.state.src
                }}

                getSize={this.getSize.bind(this)}
            />
        )
    }

    /**
     * Renders passes in text
     */
    renderText() {
        this.w = 3
        this.h = 3

        return (
            <TextPlane planeH={0} /*width={this.w} height={this.h}*/ text={this.props.item.text} />
        )
    }

    /**
     * Renders action buttons overlay
     */
    renderActions() {
        return (

            <ItemActions

                width={this.w}
                visible={this.state.hover}

                deleteClick={this.delClick.bind(this)}

                clickDownForward={() => {
                    this.setState({
                        moving: true,
                        direction: -1,
                    })
                }}

                clickDownBackward={() => {
                   this.setState({
                        moving: true,
                        direction: 1,
                    }) 
                }}

                clickUp={() => {
                    this.setState({
                        moving: false,
                    })
                }}
            />
        );
    }

    render() {
        let primitive = this.props.item.img ? this.renderImage() : this.renderText()

        return (
            <Entity>

                <Entity
                    events={{
                        mouseenter: this.itemHover.bind(this),
                        mouseleave: this.itemUnhover.bind(this),

                        depthEnd: (e) => {
                            this.props.actions.moveBox(this.props.dKey, e.detail.z)
                        }
                    }}

                    frame-depth={{
                        z: this.props.item.depth,
                        enabled: this.state.moving,
                        direction: this.state.direction,
                    }}

                    scale={this.state.scale}
                >

                    <Entity
                        events={{
                            dragEnd: (e) => this.saveRotation(e.detail.rotation),
                        }}

                        frame-box={{
                            x: this.props.item.rotation.x,
                            y: this.props.item.rotation.y,
                        }}

                        frame-button
                    >

                         {primitive} 

                    </Entity>

                    
                    {this.renderActions()}
                    

                </Entity>


            </Entity>
        )
    }

}


export default IdeaBox;



// WEBPACK FOOTER //
// ./src/components/ideaBox.js